import { AdminRouteName } from '../../../CONSTANTS';
import RentCollectionTableRecords from '../RentCollectionTableRecords';

const optionalColumn = [
  'dateActioned',
];

const optionalColumnLabelFormat = {
  dateActioned: 'Date Actioned',
};

const RefundedRentCollection = () => (
  <RentCollectionTableRecords
    optionalColumn={optionalColumn}
    optionalColumnLabelFormat={optionalColumnLabelFormat}
    defaultUrl={AdminRouteName.rentCollectionRefunded}
    toggleStorageId="awaiting_rent-collection-table-col"
    hasNameAndImage
    permissionName="can-view-rent-payment"
    tabStatus="REFUNDED"
  />
);
export default RefundedRentCollection;
